<template>
    <div class="space-y-6">
        <div class="flex justify-end">
            <div class="w-full max-w-4xl animate-pulse">
                <div class="rounded-l-lg rounded-tr-lg bg-blue-500 p-4">
                    <div class="h-4 w-3/4 rounded bg-blue-400 mb-2"></div>
                    <div class="h-4 w-1/2 rounded bg-blue-400"></div>
                </div>
            </div>
        </div>

        <div class="max-w-4xl rounded-lg border border-gray-300 bg-gray-50 animate-pulse">
            <div class="border-b border-gray-300 bg-gray-100 px-4 py-3">
                <div class="flex items-center justify-between">
                    <div class="flex items-center space-x-2">
                        <div class="h-2 w-2 rounded-full bg-blue-500"></div>
                        <div class="h-3 w-24 rounded bg-gray-200"></div>
                    </div>
                    <div class="flex items-center space-x-2">
                        <div class="h-3 w-12 rounded bg-gray-200"></div>
                        <div class="h-3 w-3 rounded bg-gray-200"></div>
                    </div>
                </div>
            </div>

            <div class="p-4 relative">
                <div
                    class="absolute left-7 w-px bg-gray-300 h-[calc(100%-2rem)]"
                    style="top: 1.75rem;"
                ></div>
                <div class="space-y-4">
                    <div
                        v-for="i in 6"
                        :key="i"
                        class="relative flex items-center space-x-2"
                    >
                        <div
                            class="relative z-10 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full border-2 border-blue-500 bg-white"
                        >
                            <div class="h-2 w-2 rounded-full bg-gray-200"></div>
                        </div>
                        <div class="flex-1 py-1">
                            <div class="flex items-center justify-between">
                                <div class="flex-1 h-3 rounded bg-gray-200"></div>
                                <div class="ml-3 flex-shrink-0 h-3 w-8 rounded bg-gray-200"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
         <div class="max-w-4xl animate-pulse p-4 space-y-4">
            <div class="h-4 w-5/6 rounded bg-gray-200"></div>
            <div class="h-4 w-full rounded bg-gray-200"></div>
            <div class="h-4 w-4/5 rounded bg-gray-200"></div>
            <div class="h-3 w-1/4 rounded bg-gray-200 mt-2"></div>

            <div class="mt-4 flex space-x-3">
                <div class="h-6 w-6 rounded-full bg-gray-200"></div>
                <div class="h-6 w-6 rounded-full bg-gray-200"></div>
                <div class="h-6 w-6 rounded-full bg-gray-200"></div>
            </div>
        </div>

        <div class="bg-white border border-gray-200 rounded-lg p-6 animate-pulse">
            <div class="flex items-center space-x-4">
                <div class="flex -space-x-6">
                    <div
                        v-for="i in 4"
                        :key="i"
                        class="h-12 w-12 rounded-full bg-gray-200 border-2 border-white"
                    ></div>
                </div>
                <div class="flex-1 space-y-2">
                    <div class="h-4 w-1/2 rounded bg-gray-200"></div>
                    <div class="h-3 w-1/3 rounded bg-gray-200"></div>
                </div>
                <div class="h-5 w-5 rounded bg-gray-200"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SkeletonAIChatMessages',
}
</script>